// Let's import menu, icons and paths

export const admin = [
  { title: "Company settings", src: "Setting", path: "/company-setting" },
  { title: "Staff", src: "User", path: "/user-management" },
  { title: "Clients", src: "User", path: "/clients" },
  { title: "Blog", src: "Chart_fill", path: "/blog" },
  { title: "Services", src: "Search", path: "/services" },
  { title: "Images", src: "Search", path: "/images" },
  { title: "Analytics", src: "Chart" },
  { title: "Profile", src: "Setting", path: "/profile" },
  { title: "My Profile", src: "User", path: "/myprofile" },
];

export const client = [
  { title: "My services", src: "Chart_fill", path: "/house" },
  { title: "Profile Settings", src: "Setting", path: "/profile" },
  { title: "My Profile", src: "Setting", path: "/myprofile" },
];
